/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaBodegasPersonasVistaProps } from '../interfaces';
import { accionesBodegaPersona, columnasBodegaPersona, opcionesBodegaPersona } from './constantes';

const VistaBodegasPersonas: React.FunctionComponent<ITablaBodegasPersonasVistaProps & InjectedIntlProps> = ({
    bodegasPersonass,
    cargarBodegasPersonas,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <Tabla
        columns={columnasBodegaPersona(intl.formatMessage)}
        data={bodegasPersonass}
        actions={accionesBodegaPersona(
            manejarFormulario,
            cargarBodegasPersonas,
            intl.formatMessage,
            confirmarEliminacion
        )}
        options={opcionesBodegaPersona}
        style={{ width: '100%' }}
    />
);

export default injectIntl(VistaBodegasPersonas);
